export { Caption1Strong, caption1StrongClassNames } from './components/presets/Caption1Strong/index';
